import { cn } from "@drpcrd/utils/shared";
import { Typography } from "../typography";

type Props = {
  className?: string;
};

/**
 * Empty state component for activity feeds when no events are available
 */
export const ActivityEmptyState = ({ className }: Props) => (
  <div className="flex h-full w-full grow flex-col">
    <div
      className={cn(
        "flex grow flex-col items-center justify-center rounded-2xl border border-neutral-500 py-2 text-center",
        className,
      )}
    >
      <Typography size="lg" weight="semibold">
        Nothing to see here
      </Typography>
      <Typography size="sm" color="neutral">
        Activity feed is available on newer missions
      </Typography>
    </div>
  </div>
);
